class APIS {
	apis() {
		return {
			accountLimitsSet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/account-limits/set'
			},
			accountLimitsGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/account-limits/get'
			},
			accountLimitsRemove: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/account-limits/remove'
			},
			templateLimitsSet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template-limits/set'
			},
			templateLimitsGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template-limits/get'
			},
			templateLimitsList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template-limits/list'
			},
			templateLimitsRemove: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template-limits/remove'
			},
			quotaUsage: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/quota-usage'
			},
			quotaReset: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/quota-reset'
			},
		};
	}
}

export default new APIS();
